import React, { Component } from 'react'
import AOS from 'aos'
import { Header, Menu, Banner, Promotion, Product, About, Contact, Footer } from '../components'
import './index.scss'

class Template extends Component {
  constructor(props) {
    super(props)

    this.promotion = React.createRef()
    this.product = React.createRef()
    this.about = React.createRef()
    this.contact = React.createRef()
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }
  handleScroll = () => {
    if (this.promotion.current) {
      const position = this.promotion.current.getBoundingClientRect()
      const top = Math.abs(position.top)
      const height = position.height
      const difference = Math.abs(height - top)
      if (difference < 100) {
        AOS.refresh()
      }
    }

    if (this.product.current) {
      const position = this.product.current.getBoundingClientRect()
      const top = Math.abs(position.top)
      const height = position.height
      const difference = Math.abs(height - top)
      if (difference < 100) {
        AOS.refresh()
      }
    }

    if (this.about.current) {
      const position = this.about.current.getBoundingClientRect()
      const top = Math.abs(position.top)
      const height = position.height
      const difference = Math.abs(height - top)
      if (difference < 100) {
        AOS.refresh()
      }
    }

    if (this.contact.current) {
      const position = this.contact.current.getBoundingClientRect()
      const top = Math.abs(position.top)
      const height = position.height
      const difference = Math.abs(height - top)
      if (difference < 100) {
        AOS.refresh()
      }
    }
  }
  render() {
    return (
      <>
        <Header />
        <div className="container-lg p-0">
          <Menu />
        </div>

        <h1 className="d-none">หน้าแรก</h1>

        <Banner />

        <div ref={this.promotion}>
          <Promotion />
        </div>

        <div className="ch-parallax-section">
          <div className="ch-parallax-child-section">
            <div className="ch-parallax">
              <div className="ch-shape" />
            </div>
          </div>
        </div>

        <div ref={this.product}>
          <Product />
        </div>

        <div ref={this.about}>
          <About />
        </div>

        <div ref={this.contact}>
          <Contact />
        </div>

        <Footer />
      </>
    )
  }
}

export default Template
